export default __webpack_public_path__ + "static/media/640_dummy2016-kunstshop01-de.3166b3f0.png";